import React from 'react';
import { IUserWorkoutSessionSummary } from 'fitbeat.models';
import { BaseModal } from '../../ui';
import WorkoutHistoryModalBody from './WorkoutHistoryModalBody';

interface IWorkoutHistoryModalProps {
  modalTitle: string;
  isModalVisible: boolean;
  closeModal: () => void;
  gender?: 'male' | 'female';
  workoutHistory: IUserWorkoutSessionSummary;
  userProfileService: unknown; // TODO: Define proper user profile service type
}

function WorkoutHistoryModal({
  modalTitle,
  isModalVisible,
  closeModal,
  gender = 'female',
  workoutHistory,
  userProfileService,
}: IWorkoutHistoryModalProps) {
  return (
    <BaseModal
      title={modalTitle}
      closeModal={closeModal}
      isModalVisible={isModalVisible}
    >
      <WorkoutHistoryModalBody
        gender={gender}
        workoutHistory={workoutHistory}
        userProfileService={userProfileService}
      />
    </BaseModal>
  );
}

WorkoutHistoryModal.defaultProps = {
  gender: 'female' as const,
};

export default WorkoutHistoryModal;
